module.exports = __webpack_public_path__ + "img/paper-megaphone.e8ff52c3.jpg";